import { useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export const ConsentGate = () => {
  const { refresh, logout } = useAuth();
  const [terms, setTerms] = useState(false);
  const [marketing, setMarketing] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/auth/consent", { terms, marketing });
      await refresh();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center p-6" data-testid="consent-gate">
      <div className="max-w-lg w-full rounded-3xl border bg-white p-8 md:p-10 fade-up">
        <ShieldCheck className="h-10 w-10 text-[#1E3A8A]" />
        <h1 className="mt-4 text-3xl font-semibold tracking-tight">Prima di iniziare</h1>
        <p className="mt-3 text-slate-600 leading-relaxed">
          Burocrazy conserva documenti personali. I tuoi dati sono tuoi: puoi esportarli o cancellarli in qualsiasi momento dalle Impostazioni.
        </p>
        <label className="mt-6 flex gap-3 items-start text-sm cursor-pointer">
          <Checkbox checked={terms} onCheckedChange={(v) => setTerms(!!v)} data-testid="consent-terms-checkbox" />
          <span>Ho letto e accetto i <Link className="underline text-[#1E3A8A]" to="/termini">Termini di servizio</Link> e l'<Link className="underline text-[#1E3A8A]" to="/privacy">Informativa privacy</Link> (obbligatorio).</span>
        </label>
        <label className="mt-4 flex gap-3 items-start text-sm cursor-pointer">
          <Checkbox checked={marketing} onCheckedChange={(v) => setMarketing(!!v)} data-testid="consent-marketing-checkbox" />
          <span>Voglio ricevere novità e consigli su Burocrazy via email (facoltativo).</span>
        </label>
        <div className="mt-8 flex gap-3">
          <Button disabled={!terms || busy} onClick={submit} className="rounded-full px-6" data-testid="consent-submit-btn">Continua</Button>
          <Button variant="ghost" onClick={logout} className="rounded-full" data-testid="consent-logout-btn">Esci</Button>
        </div>
      </div>
    </div>
  );
};
